const awards = [
  {
    id: 1,
    img: "https://i.ibb.co/r2FL0f7b/a-01.jpg",
    title: "Management Consulting Award hosted by Wealth & Finance",
  },
  {
    id: 2,
    img: "https://i.ibb.co/6cxBSmvR/a-02.jpg",
    title:
      "Eurofins Regional MD Award for Operational Excellence at South Asia",
  },
  {
    id: 4,
    img: "https://i.ibb.co/S7xVfCgD/award-02-01.jpg",
    title: "Operational Excellence Award from Akij Gooup",
  },
  {
    id: 5,
    img: "https://i.ibb.co/X6kMh1Y/a-03-01.jpg",
    title: "Award for Successful Rollout of Kaizen Project at Confidence Group",
  },
  {
    id: 10,
    img: "https://i.ibb.co/CkVgMcg/Award-Operational-Excellence-Award-by-Akij-Group.jpg",
    title: "Award- Operational Excellence Award by Akij Group",
  },
  {
    id: 3,
    img: "https://i.ibb.co/BHzBjkfj/award-01.jpg",
    title:
      "award: Mind Works & Naijur Rahman has been Appointed as OpEx Consultant for South Asian Region of Eurofins Global",
  },
  {
    id: 7,
    img: "https://i.ibb.co/x85H59PK/a-05-01.jpg",
    title: "Annual Kaizen Excellence Award at Akij Group",
  },
  {
    id: 6,
    img: "https://i.ibb.co/YgQdH1L/a-04-01.jpg",
    title: "Awards from Confidence Group",
  },
  {
    id: 9,
    img: "https://i.ibb.co/21mWw8dB/Eurofins-Regional-Managing-Director-Award-for-Successful-Implementation-of-Operational-Excellence.jpg",
    title:
      "Eurofins Regional Managing Director Award for Successful Implementation of Operational Excellence",
  },
];

export default awards;
